export class AssertionError extends Error {
  constructor(msg: string | undefined | null) {
    super("Failed assertion" + (msg ? `: ${msg}` : ""));

    Object.setPrototypeOf(this, AssertionError.prototype);
  }
}

type AssertMessage = string | undefined | null | (() => string);

export function assert(
  condition: boolean,
  msg: AssertMessage = null,
): asserts condition {
  if (!condition) {
    const error = new AssertionError(typeof msg === "function" ? msg() : msg);
    if ("captureStackTrace" in Error)
      Error.captureStackTrace(error, assert);
    throw error;
  }
}

export function assertNonNull<T>(
  v: T,
  msg: AssertMessage = null,
): asserts v is NonNullable<T> {
  assert(v != null, msg);
}

export function divmod(value:number, lambda:number): [number, number] {
  return [Math.floor(value / lambda), value % lambda];
}

export * from "./type_utils.ts";
